import React, { Component } from 'react'
// https://github.com/SheetJS/js-xlsx
import XLSX from 'xlsx'
import { Loading } from '../index'
import { connect } from 'react-redux'
import { SplitButton } from 'primereact/splitbutton'
import { Btn } from '../../components'

class ImportExcelFile extends Component {
  // Props:
  // classes: Classes to be applied to btn styles
  // label: Button´s label
  // abaName: Nome da Aba da Pasta ALVO. Default: null
  // onFileImported: callback with the JSON file imported result
  // multiple: Allow multiple file selection. Default: false
  // model: Opções extras de importação [{ label, key }]. Quando informado, o botão
  //        é renderizado como SplitButton e a key da opção escolhida é devolvida no
  //        segundo parâmetro do callback onFileImported
  // defaultOptionKey: key devolvida quando a importação é feita pelo próprio botão

  constructor(props) {
    super(props)
    this.inputFileRef = React.createRef()
    this.selectedOptionKey = null
    this.state = { isImporting: false }
  }

  onBtnClickHandler = event => {
    event.preventDefault()
    this.openFileDialog(this.props.defaultOptionKey || null)
  }

  openFileDialog = optionKey => {
    this.selectedOptionKey = optionKey
    this.inputFile.click()
  }
  componentDidMount = () => {
    this.inputFile = this.inputFileRef.current
    this.inputFile.addEventListener('change', ({ target: { files } }) => {
      if (!files || files.length === 0) return

      this.setState({ isImporting: true })

      // Se multiple=true, processar todos os arquivos
      if (this.props.multiple) {
        const fileArray = Array.from(files)
        const promises = fileArray.map(xlsFile => {
          return new Promise((resolve, reject) => {
            this._getFileUrl(xlsFile, url => {
              const contentAsString =
                this.props.selectedCiclo.file_type_id === 8 ||
                this.props.selectedCiclo.file_type_id === 37

              this._getExcelFile(url, contentAsString, result => {
                resolve(result)
              })
            })
          })
        })

        Promise.all(promises).then(results => {
          this.setState({ isImporting: false })
          // Reset Input File Value
          this.inputFile.value = null
          // Send all results back as array
          this.props.onFileImported(results, this.selectedOptionKey)
        })
      } else {
        // Processamento único (comportamento original)
        const xlsFile = files[0]

        this._getFileUrl(xlsFile, url => {
          const contentAsString =
            this.props.selectedCiclo.file_type_id === 8 ||
            this.props.selectedCiclo.file_type_id === 37

          this._getExcelFile(url, contentAsString, result => {
            this.setState({ isImporting: false })
            // Reset Input File Value
            this.inputFile.value = null
            // Send Result Back
            this.props.onFileImported(result, this.selectedOptionKey)
          })
        })
      }
    })
  }

  render() {
    return (
      <React.Fragment>
        <input
          ref={this.inputFileRef}
          style={{ display: 'none' }}
          type="file"
          accept=".csv, .xlsm, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.ms-excel.sheet.macroEnabled.12"
          multiple={this.props.multiple || false}
        />
        {this.state.isImporting ? <Loading /> : this._renderButton()}
      </React.Fragment>
    )
  }

  _renderButton = () => {
    const { model, label, classes, menuStyle } = this.props

    if (model && model.length)
      return (
        <SplitButton
          style={{ height: '35px' }}
          menuStyle={menuStyle || { width: 300 }}
          className={classes || 'bck-primary'}
          label={label}
          icon={this.props.hasIcon ? 'pi pi-upload' : null}
          onClick={this.onBtnClickHandler}
          model={model.map(item => ({
            label: item.label,
            command: () => this.openFileDialog(item.key),
          }))}
        />
      )

    return (
      <Btn disabled={this.state.isImporting} className={classes} onClick={this.onBtnClickHandler}>
        {this._hasIcon(this.props.hasIcon)} {this.props.label}
      </Btn>
    )
  }

  _hasIcon = hasIcon => {
    if (hasIcon) return <i className="pi pi-upload"></i>
  }

  _getFileUrl = (file, cb) => {
    const reader = new FileReader()
    reader.onload = info => cb(info.target.result)
    reader.readAsDataURL(file)
  }
  _getExcelFile = (url, contentAsString, cb) => {
    try {
      const req = new XMLHttpRequest()
      req.open('GET', url, true)
      req.responseType = 'arraybuffer'
      const self = this
      req.onload = function () {
        /* parse the data when it is received */
        const data = new Uint8Array(req.response)

        // Read File Content
        const workbook = XLSX.read(data, { type: 'array', raw: contentAsString })

        const first_worksheet = self.props.abaName
          ? workbook.Sheets[self.props.abaName]
          : workbook.Sheets[workbook.SheetNames[0]]
        const result = XLSX.utils.sheet_to_json(first_worksheet, { header: 1 })
        cb(result)
      }
      req.onerror = error => console.log('error [ImportExcelFile Component _getExcelFile]=>', error)

      req.send()
    } catch (error) {
      console.log('error [ImportExcelFile Component _getExcelFile]=>', error)
    }
  }
}

const mapStateToProps = ({ ciclo_entrega: { selectedCiclo } }) => ({ selectedCiclo })
export default connect(mapStateToProps)(ImportExcelFile)
